/**
 * All agent permissions
 */
export const AGENT_PERMISSIONS = {
  CanForceCancelBetSlip: 'CanForceCancelBetSlip',
  CanCancelBetSlip: 'CanCancelBetSlip',
  CanCheckBetSlip: 'CanCheckBetSlip',
  CanPlaceTickets: 'CanPlaceTickets',
  PreventAffiliateToPlaceBets: 'PreventAffiliateToPlaceBets',
  CanPrintBetSlipFromHistory: 'CanPrintBetSlipFromHistory',
  CanViewQuickBetHistory: 'CanViewQuickBetHistory',
  CanSendToManualAuthorization: 'CanSendToManualAuthorization',
  ViewAffiliatePlayers: 'ViewAffiliatePlayers',
  CanLoginOnAffiliatePortal: 'CanLoginOnAffiliatePortal',
  ViewAffiliateBetShop: 'ViewAffiliateBetShop',
  ViewAffiliateManagement: 'ViewAffiliateManagement',
  ViewPlayersManagement: 'ViewPlayersManagement',
  ViewBetShopManagement: 'ViewBetShopManagement',
  CanViewBetReport: 'CanViewBetReport',
  CanPrintFixture: 'CanPrintFixture',
  CanViewUIForTV: 'CanViewUIForTV',
  CanAddAffiliateUsers: 'CanAddAffiliateUsers',
  ViewAffiliateUsersList: 'ViewAffiliateUsersList',
  ViewVFLEntertainmentScreen: 'ViewVFLEntertainmentScreen',
  CanSeeControlCodeInReport: 'CanSeeControlCodeInReport',
  CanEditPrintFixture: 'CanEditPrintFixture',
  CanTransferMoneyToPlayer: 'CanTransferMoneyToPlayer',
  CanTransferMoneyFromPlayer: 'CanTransferMoneyFromPlayer',
  ViewAgentVouchers: 'ViewAgentVouchers',
  ModifyAgentVouchers: 'ModifyAgentVouchers',
  ViewAgentVoucherCode: 'ViewAgentVoucherCode',
  CanViewOwnAgentVouchers: 'CanViewOwnAgentVouchers',
  CanViewAgentVouchersFromParent: 'CanViewAgentVouchersFromParent',
  CanPrintAgentVouchers: 'CanPrintAgentVouchers',
  CanCancelAgentVouchers: 'CanCancelAgentVouchers',
  ViewBetShopReport: 'ViewBetShopReport',
  CanAddNewSubAgentPlayer: 'CanAddNewSubAgentPlayer',
  CanEditNewSubAgentPlayer: 'CanEditNewSubAgentPlayer',
  CanViewVideoDisplays: 'CanViewVideoDisplays',
  ViewSportBetting: 'ViewSportBetting',
  ViewSportBookExternal: 'ViewSportBookExternal',
  CanAssignOverdraft: 'CanAssignOverdraft',
  CanAddPlayers: 'CanAddPlayers',
  CanViewPlayers: 'CanViewPlayers',
  CanSeeAllPlayers: 'CanSeeAllPlayers',
  CanTransferOverdraftToAgent: 'CanTransferOverdraftToAgent',
  CanTransferOverdraftFromAgent: 'CanTransferOverdraftFromAgent',
  CanViewSubAgentOverdraftTransactions: 'CanViewSubAgentOverdraftTransactions',
  CanViewOverdraftTransactions: 'CanViewOverdraftTransactions',
  CanViewAvailableOverdraft: 'CanViewAvailableOverdraft',
  CanViewTotalNetworkOverdraft: 'CanViewTotalNetworkOverdraft',
  CanViewShortCashierReport: 'CanViewShortCashierReport',
  HidePrintInCheckBetSlip: 'HidePrintInCheckBetSlip',
  CanViewCommissioningReport: 'CanViewCommissioningReport',
  CanViewAgentTrailDetailsReport: 'CanViewAgentTrailDetailsReport',
  CanViewAgentTrailDetailsReportSubNetwork: 'CanViewAgentTrailDetailsReportSubNetwork',
  CanViewSportBookCommissioningReport: 'CanViewSportBookCommissioningReport',
  CanViewSportBookCommissioningReportForSubNetwork: 'CanViewSportBookCommissioningReportForSubNetwork',
  CanViewCommissioningNavigationMenu: 'CanViewCommissioningNavigationMenu',
  DisablePayBetslips: 'DisablePayBetslips',
  CanViewAssistedBetsForDirectPlayers: 'CanViewAssistedBetsForDirectPlayers',
  CanViewAssistedBetsForNetworkPlayers: 'CanViewAssistedBetsForNetworkPlayers',
  CanViewAssistedBetsForAllPlayers: 'CanViewAssistedBetsForAllPlayers',
  DisableCashoutAgent: 'DisableCashoutAgent',
};
